import styled, {ThemeProps} from 'styled-components';

// THEME
import {SectionHeader} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
export const AmenityInnerItemTextStylingSpan = styled.span(
  props => `
  margin-left: ${props.theme.spacing.small};
`,
);

export const AmenityInnerItemIconStylingSpan = styled.span(
  props => `
  margin-top: ${props.theme.spacing.small};
`,
);

export const AmenitiesWrapper = styled.div(
  props => `

  width: 100%;
  margin: 0 auto;
  max-width:120rem;
  background-color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};

`,
);

export const AmenitiesHeaderStyled = styled(SectionHeader)(
  props => `

  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;

`,
);

export const AmenitiesListBlock = styled.div(
  props => `

  padding: ${props.theme.spacing.xxlarge};
  border-radius: ${props.theme.misc.borderRadius.large};
  border-top-left-radius:0;
  border-top-right-radius:0;

`,
);

export const PopularAmenitiesTag = styled.span(
  props => `

  padding: ${props.theme.spacing.xsmall} ${props.theme.spacing.large} ${props.theme.spacing.xsmall} ${props.theme.spacing.small};
  background-image: linear-gradient(96deg, #1b9564, #39d546);
  border-radius: ${props.theme.misc.borderRadius.small};

`,
);

export const PopularAmenitiesTagTextStyled = styled.span(
  props => `

  color: white;
  font-weight: bold;
  text-transform: uppercase;

`,
);

export const AmentiesHorizontalListof4 = styled.ul(
  props => `

  list-style-type: none;
  display: flex;
  align-items: center;
  padding: ${props.theme.spacing.xxlarge} 0 0 0;
  font-size: ${props.theme.font.custom(16)};
`,
);

export const AmenityItemText = styled.span(
  props => `

  font-weight: bold;
  padding: 0 ${props.theme.spacing.large} 0;

`,
);

export const CategorizedAmenitiesTableContainer = styled.div(
  props => `

  display: flex;
  justify-content: space-around;
  padding: ${props.theme.spacing.xxlarge} ${props.theme.spacing.xxlarge} ${props.theme.spacing.large} ${props.theme.spacing.xxlarge};
  background: ${props.theme.colors.goWhite.base};
  border-top: 0.1rem solid ${props.theme.colors.ash.dark};

`,
);

export const OneCateoryOfAmenitiesContainer = styled.div(
  props => `

  flex: 1;
  padding: ${props.theme.spacing.base};

`,
);

export const HeadingOneCategoryOfAmenitiesBlockStyled = styled.h3(
  props => `

  font-size: ${props.theme.font.custom(16)};
  font-weight: bold;
  font-family: ${props.theme.font.fontFamily};
  padding: 0 0 ${props.theme.spacing.base} 0;

`,
);

export const OneCategoryOfAmenitiesList = styled.ul`
  list-style-type: none;
`;
export const OneCategoryOfAmenitiesListItem = styled.li(
  props => `

  font-size: ${props.theme.font.custom(16)};
  padding: 0 0 ${props.theme.spacing.base} 0;
  align-items: center;
  display: flex;

`,
);

export const HideAllAmenitiesTextContainer = styled.div(
  props => `
  padding: 0 0 ${props.theme.spacing.large} ${props.theme.spacing.xxlarge};
  color: ${props.theme.colors.goBrandBlue.base}
  font-size: ${props.theme.font.custom(16)};
`,
);

export const HideAllAmenitiesText = styled.a(
  props => `

  text-decoration: none;
  color: inherit;

`,
);
